
//Représente les paramètres d’éxécution d’une requête pour un bandeau
export class ASeExecuterRequeteBandeauParametres 
{
  //Domaine
  public domaine!: string;

  //Identifiant de l’onglet
  public identifiantOnglet!: string;
}
